/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Dok_GInputs */

const en_tut_dok_g = /** @type {(inputs: Tut_Dok_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For anything longer than a comment — proposals, minutes, budgets — use Documents. The result exports as PDF, DOCX, XLSX, PPTX, Markdown, TXT, or CSV.`)
};

const id_tut_dok_g = /** @type {(inputs: Tut_Dok_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk hal yang lebih panjang dari komentar — proposal, notulen, anggaran — pakai Dokumen. Hasilnya bisa diunduh sebagai PDF, DOCX, XLSX, PPTX, Markdown, TXT, atau CSV.`)
};

/**
* | output |
* | --- |
* | "For anything longer than a comment — proposals, minutes, budgets — use Documents. The result exports as PDF, DOCX, XLSX, PPTX, Markdown, TXT, or CSV." |
*
* @param {Tut_Dok_GInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_dok_g = /** @type {((inputs?: Tut_Dok_GInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Dok_GInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_dok_g(inputs)
	return en_tut_dok_g(inputs)
});